import { Component, Input, OnInit } from '@angular/core';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { IFilterInduccionModel } from 'src/app/models/interfaces/induccion/IFilterInduccionModel';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { SedeService } from 'src/app/services/sede/sede.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-induccion-filtros-busqueda',
  templateUrl: './induccion-filtros-busqueda.component.html',
  styleUrls: ['./induccion-filtros-busqueda.component.css']
})
export class InduccionFiltrosBusquedaComponent implements OnInit {
  @Input() modelFilter!: IFilterInduccionModel;
  listaSedes: ISedeModel[] = new Array<SedeModel>();
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();
  @Input() displayFechaAprobacion!: boolean;
  @Input() displayFechaInduccion!: boolean;
  
  constructor(
    private storage: StorageService,
    private sedeService: SedeService
  ) {
    this.listaSedes = new Array<SedeModel>();
  }

  ngOnInit(): void {
    let usuario = this.storage.getCurrentUser();
    this.listaCompanias = usuario.companias;
    this.modelFilter.idCompania = usuario.companiaDefault.idCompania;
    const filterSede: IFilterSedeModel = new FilterSedeModel();
    
    this.sedeService
      .getList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
      });
  }

  companiaChanged() {

    this.listaSedes = [];
    this.modelFilter.sedes = [];
    let filterSede: IFilterSedeModel = new FilterSedeModel();
    filterSede.companias.push(this.modelFilter.idCompania);

    this.sedeService
      .getList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
      });
  }

  addDays(currentDate: Date, days : number): Date{
    currentDate.setDate(currentDate.getDate() + days);
    return currentDate;
  }

  keyPressNumberOnly(event: any) {
    const pattern = /^[0-9]*$/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
